<template>
  <b-container>
    <b-row align-h="center" cols-lg="2" cols-sm="1">
      <b-card>
        <div class="text-center">
          <b-button
            variant="primary"
            size="lg"
            @click="loginWithAuth0"
            class="w-100"
          >
            Login
          </b-button>
        </div>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Login",
  methods: {
    async loginWithAuth0() {
      try {
        await this.$store.dispatch("auth0Login");
      } catch (error) {
        console.error('Auth0 login failed:', error);
      }
    },
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 30px;
}
</style>
